import { render, staticRenderFns } from "./DistrictAdd.vue?vue&type=template&id=961b1018&scoped=true&"
import script from "./DistrictAdd.vue?vue&type=script&lang=js&"
export * from "./DistrictAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961b1018",
  null
  
)

export default component.exports